<template>
    <div class="banner bng-sport-banner-email-bonus">
        <img
            :src="isMobilePhone ? '/static/banners/sport-home-banner/mobile/email_bonus.jpg' : '/static/banners/sport-home-banner/desktop/email_bonus.jpg'"
        />
        <div class="content">
            <div>
                <div>
                    <b>{{"components.common.banners.sport-banners.email-bonus.msg1" | translate}}</b>
                    <span>{{"components.common.banners.sport-banners.email-bonus.msg2" | translate}}</span>
                    <span>{{"components.common.banners.sport-banners.email-bonus.msg3" | translate}}</span>
                </div>
            </div>
        </div>
        <div class="detailed">
            <a @click="goToBonusRules()">{{"components.common.banners.sport-banners.email-bonus.read more" | translate}}</a>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'sport-banner-email-bonus',
    props: {
        currency: {
            type: String
        }
    },
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        }
    },
    methods: {
        async goToBonusRules() {
            await Vue.router.teleport.bonusRules();
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/email-bonus.vue